/**
 * @fileoverview Barrel exports for story-weaknesses-v1.
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
  type WeaknessIssue,
} from './schema';

// Flow
export { flow, storyWeaknessesV1AgentFlow } from './flow';

// Prompt template
export { prompt } from './prompt';
